import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerNecesitoTurno = styled(motion.div)`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 30px;

  @media (max-height: 700px) {
    padding-top: 25px;
  }
`;

export const TextNecesitoTurno = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-bottom: 25px;

  .title-saludo {
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    text-align: center;
    max-width: 365px;
    padding: 0 20px;
  }

  .title-pregunta {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    text-align: center;
    max-width: 365px;
  }

  .title-negrita {
    font-weight: bold;
  }

  @media (max-height: 700px) {
    margin-bottom: 20px;

    .title-saludo {
      font-size: 20px;
    }
  }

  @media (max-height: 600px) {
    margin-bottom: 15px;

    .title-saludo {
      font-size: 18px;
    }
  }
`;

export const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 18px;

  svg {
    width: 25px;
    height: 25px;
  }

  @media (max-height: 700px) {
    gap: 16px;
  }

  @media (max-height: 600px) {
    gap: 14px;
  }
`;
